import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 第三方样式
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'aos/dist/aos.css'
import 'highlight.js/styles/atom-one-dark.css'
import './assets/styles/main.css'

// 第三方库
import AOS from 'aos'
import hljs from 'highlight.js/lib/core'
import kotlin from 'highlight.js/lib/languages/kotlin'
import java from 'highlight.js/lib/languages/java'
import xml from 'highlight.js/lib/languages/xml'
import gradle from 'highlight.js/lib/languages/gradle'
import bash from 'highlight.js/lib/languages/bash'

hljs.registerLanguage('kotlin', kotlin)
hljs.registerLanguage('java', java)
hljs.registerLanguage('xml', xml)
hljs.registerLanguage('gradle', gradle)
hljs.registerLanguage('bash', bash)
hljs.registerLanguage('html', xml)

const app = createApp(App)
app.use(router)
app.mount('#app')

AOS.init({ duration: 700, once: true, offset: 80 })
